import script from "./selectCustomerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./selectCustomerComp.vue?vue&type=script&setup=true&lang=js"

import "./selectCustomerComp.vue?vue&type=style&index=0&id=29faaf50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29faaf50"]])

export default __exports__